import { combineReducers } from "redux";

import ContextReducer, { ContextState } from "./context.reducer";

import ScenarioReducer, { ScenarioState } from "./scenario.reducer";

/**
 * Interface du State complet de redux
 */
export interface ReducerState {
  context: ContextState;
  scenario: ScenarioState;
}

/**
 * on rassemble tous les reducers en un seul
 */
export default combineReducers<ReducerState>({
  context: ContextReducer,
  scenario: ScenarioReducer
});
